module.exports = __webpack_public_path__ + "img/banner_ipad.3a9bebd1.png";